export default "__VITE_ASSET__CdYt4dIz__"